<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Continuation`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_d8b07d160c__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_d8b07d160c__a)"><path d="M20.389400000000002 37.7703C20.2256 37.9341 20.0229 38.0536 19.8003 38.117599999999996L9.873691 40.9725C9.357059 41.1211 8.878893 40.6429 9.0274971 40.1263L11.882390000000001 30.1997C11.94641 29.9771 12.06591 29.7744 12.22969 29.6106L32.4397 9.400552C32.9738 8.866483 33.8398 8.866483 34.3738 9.400552L40.5994 15.6262C41.1335 16.16027 41.1335 17.026249999999997 40.5994 17.56036L20.389400000000002 37.7703zM30.9891 15.686589999999999L34.3134 19.0109 36.7311 16.59321 33.406800000000004 13.26888 30.9891 15.686589999999999zM28.8132 17.862479999999998L15.021930000000001 31.6538 13.679870000000001 36.3201 18.34623 34.9781 32.1375 21.186799999999998 28.8132 17.862479999999998zM32 36L35.21429 37.78571 37 41 38.78572 37.78571 42 36 38.78572 34.21429 37 31 35.21429 34.21429 32 36zM18 6L20.57143 7.42857 22 10 23.42857 7.42857 26 6 23.42857 4.571429999999999 22 2 20.57143 4.571429999999999 18 6zM4 17L6.571429999999999 18.42857 8 21 9.42857 18.42857 12 17 9.42857 15.57143 8 13 6.571429999999999 15.57143 4 17z"/></g></svg>
</template>
<script>

export default {
  name: 'IconContinuation',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
